import React from "react";

import i18n from "../../../i18n";

import { Tag } from "@blueprintjs/core";

import { userColors, userIcons } from "../../../utils/mef";
import { TicketManagement } from "../UserManagement/TicketManagement";

export default function TicketTag(props) {
  const [open, handle] = React.useState(false);

  if (props.id !== undefined && props.id !== null && parseInt(props.id) > 0)
    return (
      <>
        <Tag
          icon={userIcons[0]}
          key="ut"
          style={{ backgroundColor: userColors[0] }}
          onClick={() => {
            if (props.onOpen)
              props.onOpen();
            else
              handle(true)
          }}
          interactive={true}
        >
          {i18n.t("userType0")} n°{props.id}
        </Tag>
        {
          open ? (
            <TicketManagement
              server={props.server}
              id={props.id}
              onUpdate={() => handle(false)}
              parkLookup={props.parkLookup}
              deviceLookup={props.deviceLookup}
            />
          ) : null
        }</>
    );
  else return (null);
}